// extracted by mini-css-extract-plugin
export default {"imgContain":"nK","content":"oK","titleAndImage":"pK","title":"qK","text":"rK","rhodeTitle":"sK","shortHR":"tK","modal_root":"uK","x_mark":"vK","flavorStickModal":"wK","greenBox":"xK"};
    if(module.hot) {
      // 1738064241980
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  